import { delayedCall, ingenuity } from "@quest/base-core";
import { StackSymbolFeatureControllerFG } from "@quest/murka-games-behavior-panther/dist/Game/StackFeatureFG/StackSymbolFeatureControllerFG";
import { StackSymbolFeatureViewFG } from "@quest/murka-games-behavior-panther/dist/Game/StackFeatureFG/StackSymbolFeatureViewFG";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class StackSymbolFeatureControllerFgGame extends StackSymbolFeatureControllerFG {
  constructor(view: StackSymbolFeatureViewFG) {
    super(view);
    this.stackAnimation = "symbol_character";
  }

  protected playStackSpineAnim(reel: number, numOfSingleSym: number, col: number): void {
    const StackSpinePlayDelayTime = 10;
    if (numOfSingleSym != 1) {
      const spineContainer = this.view.getContainerByID(`Reel${reel}_1x4_Container`);
      const cloneSpine = this.view.getSpineJsonAndCloneSym(this.stackTransition);
      cloneSpine.y = this.view.json.symHeight * col;
      spineContainer.addChild(cloneSpine);
      cloneSpine.visible = true;
      cloneSpine.playAnim(`1x${numOfSingleSym}_blast`, false);
      // StackSpinePlayDelay is used to play spine with little delay after the transition spine start playing.
      delayedCall(
        "StackSpinePlayDelay" + reel + col,
        StackSpinePlayDelayTime,
        () => {
          this.cloneSpineForAnim = spineContainer.children[0];
          this.stackAnimationArray[reel - 1] = [
            this.cloneSpineForAnim,
            `Character_1X${numOfSingleSym}_Static`,
            `Character_1X${numOfSingleSym}`,
          ];
          this.cloneSpineForAnim.visible = true;
          this.cloneSpineForAnim.playAnim(`Character_1X${numOfSingleSym}`, true);
        },
        this
      );
    }
  }

  // Overrided to stop fg stack symbol animations
  stopStackSymAnimatioFG() {
    this.stackAnimationArray.length != 0 &&
      this.stackAnimationArray.forEach((data) => {
        data && data[0].playAnim(data[1], false);
      }, this);
  }

  // Overrided to play fg stack symbols win sound
  protected playStackSymAnimationFG(): void {
    super.playStackSymAnimationFG();
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.SYMBOLS_STACK_WIN_SOUND,
      1,
      false,
      SlotConstantsBehavior.SOUND_LIST_PRELOAD
    );
  }
}
